"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadScreen = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importStar(require("react"));
var styles = __importStar(require("./UploadScreen.css"));
var parentStyles = __importStar(require("./DocUploader.css"));
var DocUploader_1 = require("./DocUploader");
var Page_svg_1 = __importDefault(require("@ClientAssets/Images/docUploader/DragIcon/Page.svg"));
var Arrowup_svg_1 = __importDefault(require("@ClientAssets/Images/docUploader/DragIcon/Arrowup.svg"));
var Cloud1_svg_1 = __importDefault(require("@ClientAssets/Images/docUploader/DragIcon/Cloud1.svg"));
var Cloud2_svg_1 = __importDefault(require("@ClientAssets/Images/docUploader/DragIcon/Cloud2.svg"));
var Page_svg_2 = __importDefault(require("@ClientAssets/Images/docUploader/DropIcon/Page.svg"));
var Arrowdown_svg_1 = __importDefault(require("@ClientAssets/Images/docUploader/DropIcon/Arrowdown.svg"));
var Cloud1_svg_2 = __importDefault(require("@ClientAssets/Images/docUploader/DropIcon/Cloud1.svg"));
var Cloud2_svg_2 = __importDefault(require("@ClientAssets/Images/docUploader/DropIcon/Cloud2.svg"));
var isDraggingFile = function (dragEvent) {
    return dragEvent.dataTransfer.items.length === 1;
};
var isValidFile = function (file) {
    return file.type === "application/pdf" && file.size <= 1000 * 1000 * 25;
};
var UploadScreen = function (_a) {
    var onUpload = _a.onUpload;
    var _b = __read((0, react_1.useState)(""), 2), errorMessage = _b[0], setErrorMessage = _b[1];
    var _c = __read((0, react_1.useState)(false), 2), isDragging = _c[0], setIsDragging = _c[1];
    var fileInputRef = (0, react_1.useRef)(null);
    var handleUpload = function (file) {
        if (isValidFile(file)) {
            onUpload(file);
        }
        else {
            setErrorMessage("The file exceeds the size limit or isn't in a supported format. Please try again.");
        }
    };
    return (react_1.default.createElement("div", { className: styles.uploadContainer, onDragOver: function (event) {
            setErrorMessage("");
            if (isDraggingFile(event)) {
                event.preventDefault();
                setIsDragging(true);
            }
        }, onDragLeave: function () {
            setIsDragging(false);
        }, onDrop: function (event) {
            if (isDraggingFile(event) && event.dataTransfer.files[0]) {
                event.preventDefault();
                setIsDragging(false);
                var file = event.dataTransfer.files[0];
                handleUpload(file);
            }
        } },
        !!errorMessage && (react_1.default.createElement(kaleidoscope_1.Stack, { align: "center" },
            react_1.default.createElement(DocUploader_1.ErrorStrap, { text: errorMessage }))),
        react_1.default.createElement(kaleidoscope_1.Stack, { align: "center", justify: "center", className: styles.dropzone({ isDragging: isDragging }) },
            react_1.default.createElement(kaleidoscope_1.Stack, { gap: "m", align: "center", justify: "end", className: styles.instructionsContainer },
                react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.instructions, align: "center", gap: "m" },
                    react_1.default.createElement("div", { className: styles.imageContainer },
                        react_1.default.createElement("div", { className: styles.image({ show: isDragging }) },
                            react_1.default.createElement(kaleidoscope_1.SVG, { src: Cloud2_svg_2.default, className: styles.dropCloudLeft({ show: isDragging }) }),
                            react_1.default.createElement("div", { className: styles.pageIconContainer },
                                react_1.default.createElement(kaleidoscope_1.SVG, { src: Page_svg_2.default, className: styles.pageIconParts() }),
                                react_1.default.createElement(kaleidoscope_1.SVG, { src: Arrowdown_svg_1.default, className: styles.pageIconParts() })),
                            react_1.default.createElement(kaleidoscope_1.SVG, { src: Cloud1_svg_2.default, className: styles.dropCloudRight({ show: isDragging }) })),
                        react_1.default.createElement("div", { className: styles.image({ show: !isDragging }) },
                            react_1.default.createElement(kaleidoscope_1.SVG, { src: Cloud2_svg_1.default, className: styles.dragCloudLeft({ show: !isDragging }) }),
                            react_1.default.createElement("div", { className: styles.pageIconContainer },
                                react_1.default.createElement(kaleidoscope_1.SVG, { src: Page_svg_1.default, className: styles.pageIconParts() }),
                                react_1.default.createElement(kaleidoscope_1.SVG, { src: Arrowup_svg_1.default, className: styles.pageIconParts() })),
                            react_1.default.createElement(kaleidoscope_1.SVG, { src: Cloud1_svg_1.default, className: styles.dragCloudRight({ show: !isDragging }) }))),
                    isDragging ? (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(kaleidoscope_1.Stack, { align: "center", gap: "xs" },
                            react_1.default.createElement(kaleidoscope_1.Heading, { level: "4", strong: true, className: parentStyles.headingColorOverride }, "Release your Doc here"),
                            react_1.default.createElement(kaleidoscope_1.Stack, { align: "center" },
                                react_1.default.createElement(kaleidoscope_1.Text, { size: "s", className: parentStyles.textColorOverride }, "to start the upload"))))) : (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(kaleidoscope_1.Stack, { align: "center", gap: "xs" },
                            react_1.default.createElement(kaleidoscope_1.Heading, { level: "4", strong: true, className: parentStyles.headingColorOverride }, "Drag your Doc here"),
                            react_1.default.createElement(kaleidoscope_1.Stack, { align: "center" },
                                react_1.default.createElement(kaleidoscope_1.Text, { size: "xs", className: parentStyles.textColorOverride }, "Supported formats: .pdf"),
                                react_1.default.createElement(kaleidoscope_1.Text, { size: "xs", className: parentStyles.textColorOverride }, "Max file size: 25 MB"))))))),
            react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.footer({ isDragging: isDragging }), align: "center", justify: "spaceBetween", paddingBottom: "xl" },
                react_1.default.createElement(kaleidoscope_1.Button, { size: kaleidoscope_1.ButtonSize.Medium, type: kaleidoscope_1.ButtonType.Secondary, onClick: function () {
                        var _a;
                        setErrorMessage("");
                        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
                    } },
                    "Or click to browse",
                    react_1.default.createElement("input", { type: "file", className: styles.fileInput, ref: fileInputRef, accept: ".pdf", onChange: function () {
                            if (!fileInputRef.current)
                                return;
                            if (!fileInputRef.current.files)
                                return;
                            var file = fileInputRef.current.files[0];
                            handleUpload(file);
                        }, tabIndex: -1 })),
                react_1.default.createElement(kaleidoscope_1.Text, { size: "xs", className: styles.disclaimer },
                    "Qwilr uses AI to convert your doc into a Qwilr page. By using it, you agree to its",
                    " ",
                    react_1.default.createElement(kaleidoscope_1.Link, { href: "https://qwilr.com/terms", target: "_blank" }, "Terms"))))));
};
exports.UploadScreen = UploadScreen;
